import { get, patch } from 'config/api/config';

const APPLICANTS_ENDPOINT = '/lead-profile/applicants';
const APPLICANTS_REMOVE_ENDPOINT = `${APPLICANTS_ENDPOINT}/remove`;

export const getApplicants = async (id: string) => {
  const response = await get(`${APPLICANTS_ENDPOINT}/${id}`);
  return response;
};

export interface RemoveLeadProfileApplicantPayload {
  entrataApplicationId: number;
  entrataApplicantId: number;
  companyUserId: number;
}

export const removeLeadProfileApplicant = async (
  payload: RemoveLeadProfileApplicantPayload,
): Promise<void> => {
  await patch(APPLICANTS_REMOVE_ENDPOINT, payload);
};
